import { Component, OnInit ,Input} from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-ext-nav',
  templateUrl: './ext-nav.component.html',
  styleUrls: ['./ext-nav.component.sass']
})
export class ExtNavComponent implements OnInit {
  public permissions=JSON.parse(atob(sessionStorage.getItem("permissions")));
  public modules:any;
  public modulesobj:[];
  @Input() type;

  constructor(private global: GlobalService, private router: Router) { }

  ngOnInit() {
    this.modules='';
    this.modules+= '{"modules":['
    for(var i=0;i<this.permissions.permission.length;i++){
      this.modules+=JSON.stringify(this.permissions.permission[i]);
      if(this.permissions.permission[i].child==null||this.permissions.permission[i].child==undefined||this.permissions.permission[i].child.length==0){
        if(i==this.permissions.permission.length-1){
        }
        else{
            this.modules+=',';
        }
      }
      else{
        this.modules+=',';
        for(var k=0;k<this.permissions.permission[i].child.length;k++){
          this.modules+=JSON.stringify(this.permissions.permission[i].child[k]);
          if(k==this.permissions.permission[i].child.length-1 && i==this.permissions.permission.length-1){

          }
          else{
            this.modules+=',';
          }
        }
      }
    }
    this.modules+= ']}';
    this.modulesobj=JSON.parse(this.modules);
  }

    goTo(url) {
      console.log(url)
      if (url === 'https://tienda.claropr.com/') {
        this.global.goStore()
      } else {
        this.router.navigate([url])
      }
  }

}
